import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_TERRITORIES_RELEVANCE_LOG: TDatadogErrorLog = {
  from: 'src/modules/niche/niche-chart-selector',
  name: 'Get territories relevance data',
  message: 'Failed to fetch territories relevance',
}

export const GET_TERRITORIES_VIEWS_LOG: TDatadogErrorLog = {
  from: 'src/modules/niche/niche-chart-selector',
  name: 'Get territories views data',
  message: 'Failed to fetch territories views',
}
